import React from 'react';
import { connect } from 'react-redux';
import { API_URL } from '../config/constants';
import generateSpecialItem from '../utils/generateSpecialItem';

import { 
    setFoodItemPanel, 
    setPizzaPanel, 
    setSpecialPanel 
} from '../actions/panels';

import {
    openFoodItem,
    openPizza,
    openCustomPizza,
    openSpecial
} from '../actions/modals';

import {
    loadCurrentMenuItem
} from '../actions/currentMenuItem';

import { 
    cartItemReset, 
    cartItemUpdateId, 
    cartItemLoadChoices, 
    cartItemLoadToppings,
    cartItemUpdateCrust,
    cartItemUpdateSauce,
    cartItemUpdatePrice,
    cartItemUpdateMaxToppings,
    cartItemLoadSpecialItems,
    cartItemUpdatePizzaType,
    cartItemLoadModifiers
} from '../actions/cartItem';

class MenuListItem extends React.Component {

    constructor(props) {
        super(props);

        this.handleMenuItemSelection = this.handleMenuItemSelection.bind(this);
    }

    renderFoodMenuImage() {
        
        if ( this.props.food && this.props.food.thumb_image ) {
            let foodImage = API_URL +  "/" + this.props.food.thumb_image
            return (
                    <img src={foodImage} className="foodImage"  onError={i => i.target.style.display='none'} />
            );
            
        }
    }

    handleMenuItemSelection() {

        switch (this.props.menuItemType) {

            case "pizza":

                this.props.dispatch(loadCurrentMenuItem('pizza', this.props.food));
                this.props.dispatch(setPizzaPanel('info'));
                this.props.dispatch(cartItemReset());
                this.props.dispatch(cartItemUpdateId(this.props.food.id));

                // set up the default state of the toppings
                let defaultToppings = [];
                if (this.props.food.toppings.length > 0) {
                    this.props.food.toppings.forEach((theTopping) => {
                        if (theTopping.isdefault) {
                            let newDefaultTopping = {
                                isdefault: true,
                                id: theTopping.id,
                                amount: "include",
                                portion: "W",
                            };
                            defaultToppings.push(newDefaultTopping);
                        }
                    });
                    this.props.dispatch(cartItemLoadToppings(defaultToppings));
                }


                // set up the default state of the crusts
                if (this.props.food.crusts.length > 0) {
                    this.props.dispatch(cartItemUpdateCrust(this.props.food.crusts[0].id))
                }
                
                // set up the default state of the sauces
                if (this.props.food.sauces.length > 0) {
                    this.props.dispatch(cartItemUpdateSauce(this.props.food.sauces[0].id))
                }

                // set up the default state of the price
                this.props.dispatch(cartItemUpdatePrice(this.props.food.prices[0].id, this.props.food.prices[0].size_name, this.props.food.prices[0].price));

                this.props.dispatch(openPizza());
                break;

            case "custompizza":

                this.props.dispatch(setPizzaPanel('info'));
                this.props.dispatch(cartItemReset());
                this.props.dispatch(cartItemUpdatePizzaType("custom"));

                // set up the default max toppings
                this.props.dispatch(cartItemUpdateMaxToppings(this.props.currentLocation.customPizzas[0].max_toppings));

                // set up the default state of the price
                this.props.dispatch(cartItemUpdatePrice(this.props.currentLocation.pizzaSizes[0].id, this.props.currentLocation.pizzaSizes[0].size_name, 0));

                // set up the default state of the crusts
                if (this.props.currentLocation.customCrusts.length > 0) {
                    this.props.dispatch(cartItemUpdateCrust(this.props.currentLocation.customCrusts[0].id))
                }
                
                // set up the default state of the sauces
                if (this.props.currentLocation.customSauces.length > 0) {
                    this.props.dispatch(cartItemUpdateSauce(this.props.currentLocation.customSauces[0].id))
                }  
                
                this.props.dispatch(openCustomPizza());
                break;

            case "special":

                this.props.dispatch(loadCurrentMenuItem('special', this.props.food));
                this.props.dispatch(setSpecialPanel('info'));
                this.props.dispatch(cartItemReset());
                this.props.dispatch(cartItemUpdateId(this.props.food.id));

                let initialItems = [];

                // set up the default state of the special items
                this.props.food.items.forEach((theItem) => {
                
                    // check if it's a custom pizza
                    initialItems.push(generateSpecialItem(theItem.choices[0]));
                });
                
                this.props.dispatch(cartItemLoadSpecialItems(initialItems));

                this.props.dispatch(openSpecial());
                
                break;

            case "fooditem":
                this.props.dispatch(loadCurrentMenuItem('fooditem', this.props.food));
                this.props.dispatch(setFoodItemPanel('info'));

                // nothing here yet, delete if not required
                this.props.dispatch(cartItemReset());
                this.props.dispatch(cartItemUpdateId(this.props.food.id));

                if (this.props.food.choices) {
                    // set up the default state of the choices
                    const initialChoiceSelections = this.props.food.choices.map((theChoice) => {
                        if (theChoice.is_multiple == 1) {
                            return {
                                id: theChoice.id,
                                is_multiple: 1,
                                item_name: 'No Items selected.',
                                item_price: 0.00,
                                items: [],
                                max_choices: theChoice.max_choices
                            }
                        }
                        else {
                            return {
                                id: theChoice.id,
                                name: theChoice.name,
                                is_multiple: 0,
                                item_name: theChoice.selections[0].name,
                                item_price: theChoice.selections[0].price,
                                item_id: theChoice.selections[0].id,
                            }
                        }
                    });

                    this.props.dispatch(cartItemLoadChoices(initialChoiceSelections));
                }

                if (this.props.food.modifiers) {
                    const initialModifiers = this.props.food.modifiers.map((foodItemModifier) => {
                        
                        const items = [];
                        foodItemModifier.modifier.items.forEach((item) => {
                            if(item.enabled == 1 && items.length < foodItemModifier.min){
                                items.push({
                                    id: item.id,
                                    name: item.name,
                                    price: item.prices[0].price    
                                });
                            }
                        });
                        
                        return {
                            foodItemModifierID: foodItemModifier.id,
                            min: foodItemModifier.min,
                            max: foodItemModifier.max,
                            items: items
                        }
                    });
        
                    this.props.dispatch(cartItemLoadModifiers(initialModifiers));
                }
        
                // set up the default state of the price
                if (this.props.food.prices && this.props.food.prices.length > 0) {
                    this.props.dispatch(cartItemUpdatePrice(this.props.food.prices[0].id, this.props.food.prices[0].name, this.props.food.prices[0].price));
                }
                this.props.dispatch(openFoodItem());
                break;
        }
    }

    render() {
        return (
            <div className="menuItemWrapper" onClick={this.handleMenuItemSelection}>
                <div className="menuItemsWrapper">
                    <div className={ (this.props.food && this.props.food.thumb_image) ? "menuItemsWrapper withImage" : "menuItemsWrapper" }>
                        <div>
                            {this.renderFoodMenuImage()}
                        </div>
                            <div className="foodTitleAndDescription">
                                <div className="menuItem">{(this.props.isCustomPizza) ? "Build Your Own Pizza" : this.props.food.name}</div>
                                {(this.props.food && this.props.food.description != null && this.props.food.description != "") && (
                                        <div className="itemDescription">
                                            {(this.props.food.description.length >= 75) ? this.props.food.description.substring(0, 75)+"..." : this.props.food.description}
                                        </div>
                                )}     
                            </div>
                    </div>
                </div>
                <div className="priceWrapper">
                    {( this.props.isCustomPizza == false || this.props.isCustomPizza == null && this.props.food.price) ? (
                        <div>
                            <div className="price inMenu">$</div>
                            <div className="price inMenu">{this.props.food.price}</div>
                        </div>
                    ) : null }

                    {( this.props.isCustomPizza == true || this.props.food.prices == null) ? null : (
                            <div>
                            <div className="price inMenu">$</div>
                            <div className="price inMenu">{this.props.food.prices[0].price}</div>
                        </div>
                    )}           
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {

    return {
        assets_url: state.currentLocation.info.assets_url,
        currentLocation: state.currentLocation.info
    };
};


export default connect(mapStateToProps)(MenuListItem);
